module.exports = __webpack_public_path__ + "img/mpQRCode.335f9541.webp";